import { AstraParagraph, astraTwMerge, format, getToday, isHoliday, isSameDate, RowType } from '~/astra'
import { IdDate } from '~/storm'
import { getHolidayStyles } from '~/utils/utils'

import { getWeekDividerStyles } from '../../../TablesLayout/shared/styles'

export const usePreviewHeaders = (): RowType<IdDate>[] => {
    const shouldShowWeekNumber = ({ date }: IdDate) => date.day() === 1 || date.date() === 1

    return [
        {
            key: 'preview-week-number',
            rowHeader: () => null,
            cellRender: date => (shouldShowWeekNumber(date) ? <AstraParagraph className="p-1 text-center">Uke {date.date.isoWeek()}</AstraParagraph> : null),
            cellClassName: date =>
                astraTwMerge('overflow-visible border-r-0', getWeekDividerStyles(date.date), shouldShowWeekNumber(date) ? 'z-elevated' : '-z-elevated'),
        },
        {
            key: 'preview-date',
            rowHeader: () => null,
            cellRender: ({ date }) => (
                <AstraParagraph className={astraTwMerge('p-1 text-center capitalize', isHoliday(date) ? 'text-critical' : 'text-muted')}>
                    {format(date, 'DD')}
                </AstraParagraph>
            ),
            cellClassName: ({ date }) => astraTwMerge(getWeekDividerStyles(date), getHolidayStyles(date), isSameDate(date, getToday()) ? 'calendar-today' : ''),
        },
    ]
}
